import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Link,
} from '@mui/material';

const ReturnPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={1} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Return, Refund, and Cancellation Policy
        </Typography>
        
        <Typography variant="body1" paragraph>
          We aim to provide the best User experience to our Users beginning from placing an order and/or booking an appointment to initiating a return. While transacting on the Website, you can expect a hassle-free experience in returning the Product and cancelling the Services that you have ordered/booked and can rely on us as your preferred shopping destination or Service location.
        </Typography>
        
        <Typography variant="body1" paragraph>
          This return, refund, and cancellation policy ("Policy"), together with the Terms and Conditions [accessible at https://www.pharmaman.com/terms-and-conditions] sets out PharmaMan's procedures and policies in accepting: (a) Return, (b) Refund, and (c) Cancellation thereof. Any return or cancellation of Products or Services by you are subject to the terms and conditions set out under this Policy.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          APPLICABILITY OF POLICY
        </Typography>
        
        <Box component="ol" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1" paragraph>
            By agreeing to use the Website and/or placing a request for purchase of Product(s) and/or Services on the Website, you agree to be bound by the terms contained in this Policy without modification. If you do not agree to the terms contained in this Policy, you are advised not to transact on the Website.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Please note that we may from time to time change the terms of the Policy that govern your return, refund, and cancellation of an order for Products on the Website. Every time you wish to use the Website, please check the Policy to ensure you understand the terms and conditions that apply at that time.
          </Typography>
        </Box>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          TERMS FOR CANCELLATION, RETURN AND REFUND OF ORDERS
        </Typography>
        
        <Typography variant="body1" paragraph>
          Please carefully read all the parts to understand the conditions applicable in case of returns, refunds and cancellation of a Product.
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
          (A) RETURN POLICY:
        </Typography>
        
        <Typography variant="h6" component="h4" gutterBottom>
          i. Return Policy:
        </Typography>
        
        <Typography variant="body1" paragraph>
          We do our best to ensure that the products you order are delivered according to your specifications. However, should you receive an (a) incomplete order, (b) expired product, (c) damaged product, (d) incorrect product, (e) doctor changes the prescription (f) death of a patient, please notify PharmaMan User Support immediately within 7 days of receiving the products, to ensure prompt resolution. Please note that PharmaMan will not accept liability for such delivery issues if you fail to notify us within 7 days of receipt.
        </Typography>
        
        <Typography variant="body1" paragraph>
          User cannot return non-refundable Product; it is User's responsibility to check whether the Product falls under returnable/non-returnable category before placing an order.
        </Typography>

        <Typography variant="h6" component="h4" gutterBottom>
          ii. Return Policy Exceptions:
        </Typography>
        
        <Typography variant="body1" paragraph>
          Please note that we are unable to offer replacements or exchanges for the following product categories: Injections, Health Monitor & Equipment and Ortho Support.
        </Typography>
        
        <Typography variant="body1" paragraph>
          Also, PharmaMan reserves the right to refuse returns (or refunds) for certain products, as marked in the respective product pages as "Note: This item cannot be returned for a refund or exchange".
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
          (B) REFUND POLICY:
        </Typography>
        
        <Typography variant="h6" component="h4" gutterBottom>
          i. Refund Policy:
        </Typography>
        
        <Typography variant="body1" paragraph>
          At PharmaMan, we do our best to ensure that you are completely satisfied with our products. And we are happy to issue a full refund based on the conditions listed below:
        </Typography>

        <Typography variant="h6" component="h4" gutterBottom>
          ii. Full Refund Possible If:
        </Typography>
        
        <Box component="ol" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1">you received a defective item</Typography>
          <Typography component="li" variant="body1">the ordered item(s) is lost or damaged during transit.</Typography>
          <Typography component="li" variant="body1">you have received the product that has crossed the expiry date</Typography>
        </Box>
        
        <Typography variant="body1" paragraph>
          It is hereby clarified that in-case return is requested for reasons attributable to the User, We may at our discretion accept such request subject to levy of a 'Restocking Fee' to the User. It may be noted that the amount shall be refunded to you after adjusting the Re-stocking Fee. We reserve the right to revise the said Restocking Fee from time to time without any advance notice to the User. It is further clarified We may accept return request only for those products which are original, unused condition, has not been damaged or mistreated, has no signs of use, scratches, wear or tear, and is in condition for resale as new.
        </Typography>

        <Typography variant="h6" component="h4" gutterBottom>
          iii. Please note:
        </Typography>
        
        <Typography variant="body1" paragraph>
          Mode of refund may vary depending on circumstances. If the mode of refund is by Credit/Debit Card or Net Banking, please allow 7 to 10 working days for the credit to appear in your account. While we regret any inconvenience caused by this time frame, it is the bank's policy that delays the refund timing, and we have no control over that. If the mode of refund is by wallet, credit should be available within 24 hours.
        </Typography>

        <Typography variant="h6" component="h4" gutterBottom>
          iv. Cash on Delivery:
        </Typography>
        
        <Typography variant="body1" paragraph>
          In order to process such refunds for COD orders, the User will be required to send an email to <Link href="mailto:support@pharmaman.com">support@pharmaman.com</Link> or call us at +91 7200712345. Thereafter, the User will receive a refund to his/her wallet or User's bank account. In case if it is to be refunded to User's bank account, the User will have to provide the bank account details.
        </Typography>

        <Typography variant="h6" component="h4" gutterBottom>
          v. In those cases, the amount shall be refunded back to the source account of the User.
        </Typography>
        
        <Typography variant="body1" paragraph>
          If the User chooses to get the amount into the Wallet, then at the time of deactivation of the User's account, the amount that is unused in his/her wallet account will be transferred back to User's bank account.
        </Typography>

        <Typography variant="h6" component="h4" gutterBottom>
          vi. PharmaMan shall directly refund to the User's bank account during situations such as:
        </Typography>
        
        <Box component="ol" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1">When excessive price has been charged/collected from the User and amount needs to be refunded;</Typography>
          <Typography component="li" variant="body1">Any other cases where PharmaMan has to refund the amount to the User which belongs to the User shall be refunded to original payment mode.</Typography>
        </Box>
        
        <Typography variant="body1" paragraph>
          If the User chooses to get the refund to the wallet during the above-mentioned scenarios [as per clause B(v)], at the time of deactivation of the User's account, any amount that is unused in the wallet shall be transferred to the User's Bank account.
        </Typography>

        <Typography variant="h6" component="h4" gutterBottom>
          a. How to Request a Refund:
        </Typography>
        
        <Typography variant="body1" paragraph>
          To request a refund, simply email us your order details, including the reason why you're requesting a refund. We take User feedback very seriously and use it to constantly improve our quality of service.
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
          (C) CANCELLATION:
        </Typography>
        
        <Typography variant="h6" component="h4" gutterBottom>
          i. Product Cancellation:
        </Typography>
        
        <Typography variant="body1" paragraph>
          User may cancel the order of a product before it is out for delivery. On the receipt of order cancellation request, your order will be cancelled with immediate effect.
        </Typography>

        <Typography variant="h6" component="h4" gutterBottom>
          ii. Service Cancellation:
        </Typography>
        
        <Typography variant="body1" paragraph>
          The Website shall only connect the User with the Doctor/registered medical practitioners of the service booked. Once the appointment has been made and a confirmation has been given to the User, the Company shall inform the Doctor/registered medical practitioners who shall render the consult at the agreed time, location and mode provided at the time of booking the service. We are in no way liable for any deficiency of services if any arises including but not limited to cancellation of order due to unavailability of the Doctor/registered medical practitioners.
        </Typography>
        
        <Typography variant="body1" paragraph>
          Once an appointment has been made and it is confirmed at our end, no amount shall be refunded, in the event of a cancellation. However, in certain circumstances, the Company at its discretion shall permit a refund of the full or partial amount if the Doctor/registered medical practitioners becomes unavailable or if an alternative Doctor/registered medical practitioners is arranged to consult. The decision of the Company shall be final in such cases.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          User Complaints
        </Typography>
        
        <Typography variant="body1" paragraph>
          If you have any queries, do call our help desk at +91 72007-12345, email us at <Link href="mailto:support@pharmaman.com">support@pharmaman.com</Link>, or contact our User support executives through online chat. We're here for you!
        </Typography>
      </Paper>
    </Container>
  );
};

export default ReturnPolicy;